<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "primary-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.8999 9.7499C3.8999 6.95819 6.43021 2.6499 11.9999 2.6499C17.5696 2.6499 20.0999 6.95819 20.0999 9.7499V20.1499C20.0999 20.8126 19.5626 21.3499 18.8999 21.3499H11.9999V20.1499H18.8999V18.8499H15.8999V12.6499H18.8999V9.7499C18.8999 7.54161 16.8302 3.8499 11.9999 3.8499C7.16959 3.8499 5.0999 7.54161 5.0999 9.7499V12.6499H8.0999V18.8499H5.0999C4.43716 18.8499 3.8999 18.3126 3.8999 17.6499V9.7499ZM5.0999 13.8499V17.6499H6.8999V13.8499H5.0999ZM18.8999 13.8499H17.0999V17.6499H18.8999V13.8499Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
